<template>
    <svg
        fill="none"
        height="95"
        viewBox="0 0 85 95"
        width="85"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M71.478 59.9204V40.9558C71.478 28.6723 63.992 17.8377 53.2218 13.4104C53.3988 12.6216 53.4956 11.8167 53.4956 10.9957C53.4956 4.92623 48.5693 8.34465e-07 42.5001 8.34465e-07C36.4309 8.34465e-07 31.5044 4.92623 31.5044 10.9957C31.5044 11.7845 31.6009 12.5734 31.7621 13.33C21.0723 17.6125 13.5219 28.0607 13.5219 40.2635V59.9204C13.5219 62.3997 11.5096 64.412 9.03032 64.412C4.82856 64.412 1.07752 67.4868 0.675067 71.6728C0.224351 76.4703 3.99148 80.5112 8.69248 80.5112H13.5222H71.4786H76.3083C81.0093 80.5112 84.7764 76.4703 84.3257 71.6728C83.9232 67.4871 80.1722 64.412 75.9704 64.412C73.4906 64.412 71.478 62.3997 71.478 59.9204ZM46.9917 11.6556C45.8648 11.4786 44.7218 11.3497 43.5627 11.3014C41.663 11.237 39.8116 11.3657 38.0085 11.6556C37.9763 11.4462 37.9442 11.237 37.9442 11.0115C37.9442 8.50004 39.9889 6.4556 42.5001 6.4556C45.0116 6.4556 47.0561 8.50004 47.0561 11.0115C47.0561 11.237 47.0239 11.4464 46.9917 11.6556Z"
            fill="#E9E9E9" />
        <path
            d="M53.705 85.0025C53.7694 84.3263 53.2543 83.7308 52.5781 83.7308H32.4222C31.746 83.7308 31.2309 84.3266 31.3114 85.0025C31.9393 90.621 36.7044 95 42.5002 95C48.2959 95 53.061 90.621 53.705 85.0025Z"
            fill="#E9E9E9" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
